// Import System requirements
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueBus from 'vue-bus'

import { sync } from 'vuex-router-sync'
import routes from './routes'
import store from './store'
import utils from './utils'
import config from './config'
import global from './components/Global.vue'
import VueQrcode from '@chenfengyuan/vue-qrcode'

// Import Helpers for filters
import { domain, count, prettyDate, pluralize } from './filters'

// Import Views - Top level
import AppView from './components/App.vue'

// Import Install and register helper items
Vue.filter('count', count)
Vue.filter('domain', domain)
Vue.filter('prettyDate', prettyDate)
Vue.filter('pluralize', pluralize)

Vue.use(VueRouter)
Vue.use(VueBus)
Vue.component(VueQrcode.name, VueQrcode)
// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  linkExactActiveClass: 'active',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (process.env.APP_ENV !== 'develop-burg' || process.env.APP_ENV !== 'develop-cn') {
    // 需要跳转到Burg服务器
    if (utils.checkIsNeedToGoBurg(to)) {
      if (
        !router.app.$store.state.user.uid ||
        router.app.$store.state.user.uid === 'null'
      ) {
        let urlstr = config.burgURI + to.fullPath
        utils.goUri(urlstr)
      } else {
        let urlstrs =
          config.burgURI +
          to.fullPath +
          '&u=' +
          router.app.$store.state.user.uid +
          '&p=' +
          router.app.$store.state.user.pw +
          '&apr=' +
          window.localStorage.getItem('appper')
        utils.goUri(urlstrs)
      }
      return
    }

    // 需要跳转到CN服务器
    if (utils.checkIsNeedToGoCN(to)) {
      if (
        !router.app.$store.state.user.uid ||
        router.app.$store.state.user.uid === 'null'
      ) {
        let urlstr = config.cnURI + to.fullPath
        utils.goUri(urlstr)
      } else {
        let urlstrs =
          config.cnURI +
          to.fullPath +
          '&u=' +
          router.app.$store.state.user.uid +
          '&p=' +
          router.app.$store.state.user.pw +
          '&apr=' +
          window.localStorage.getItem('appper')
        utils.goUri(urlstrs)
      }
      return
    }

    if (utils.checkIsNeedToLogin(to)) {
      utils.login(
        to.query.u,
        utils.getDecodeRC4Hex(to.query.p, global.APP_SECRET),
        function (isSuccess, myJson) {
          if (isSuccess) {
            router.app.$store.commit('SET_USER', myJson)
            router.app.$store.commit('SET_TOKEN', myJson.token)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(myJson))
              window.localStorage.setItem('token', myJson.token)
              window.localStorage.setItem('appper', to.query.apr)
            }
            let urlstr = to.path + '?'
            for (let key in to.query) {
              if (key === 'u' || key === 'p') {
                continue
              }
              utils.log(key)
              urlstr = urlstr + key + '=' + to.query[key] + '&'
            }
            next({
              path: urlstr
            })
          } else {
            next({
              path: '/login'
            })
          }
        }
      )
      return
    }

    if (
      to.matched.some(record => record.meta.requiresAuth) &&
      (!router.app.$store.state.token ||
        router.app.$store.state.token === 'null')
    ) {
      // this route requires auth, check if logged in
      // if not, redirect to login page.
      window.console.log('Not authenticated')
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else {
    if (utils.checkIsNeedToGoBlackhole(to)) {
      let urlstr = config.blackholeURI + to.fullPath
      if (
        !(
          !router.app.$store.state.user.uid ||
          router.app.$store.state.user.uid === 'null'
        )
      ) {
        if (to.fullPath === '/') {
          urlstr =
            urlstr +
            '?' +
            'u=' +
            router.app.$store.state.user.uid +
            '&p=' +
            router.app.$store.state.user.pw +
            '&apr=' +
            window.localStorage.getItem('appper')
        } else {
          urlstr =
            urlstr +
            '&u=' +
            router.app.$store.state.user.uid +
            '&p=' +
            router.app.$store.state.user.pw +
            '&apr=' +
            window.localStorage.getItem('appper')
        }
      }
      utils.goUri(urlstr)
    } else if (utils.checkIsNeedToLogin(to)) {
      utils.login(
        to.query.u,
        utils.getDecodeRC4Hex(to.query.p, global.APP_SECRET),
        function (isSuccess, myJson) {
          if (isSuccess) {
            router.app.$store.commit('SET_USER', myJson)
            router.app.$store.commit('SET_TOKEN', myJson.token)

            if (window.localStorage) {
              window.localStorage.setItem('user', JSON.stringify(myJson))
              window.localStorage.setItem('token', myJson.token)
              window.localStorage.setItem('appper', to.query.apr)
            }
            next({
              path:
                to.path +
                '?appid=' +
                to.query.appid +
                '&appname=' +
                to.query.appname
            })
          } else {
            next({
              path: '/login'
            })
          }
        }
      )
    } else if (
      to.matched.some(record => record.meta.requiresAuth) &&
      (!router.app.$store.state.token ||
        router.app.$store.state.token === 'null')
    ) {
      window.console.log('Not authenticated')
      next({
        path: '/login'
      })
    } else {
      next()
    }
  }
})

sync(store, router)

// Check local storage to handle refreshes
if (window.localStorage) {
  var localUserString = window.localStorage.getItem('user') || 'null'
  var localUser = JSON.parse(localUserString)

  if (localUser && store.state.user !== localUser) {
    store.commit('SET_USER', localUser)
    store.commit('SET_TOKEN', window.localStorage.getItem('token'))
  }
}

utils.initPluginDataMap()

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#root',
  router: router,
  store: store,
  render: h => h(AppView)
})

export default {
  logout: function () {
    store.commit('SET_USER', null)
    store.commit('SET_TOKEN', null)

    if (window.localStorage) {
      window.localStorage.setItem('user', null)
      window.localStorage.setItem('token', null)
    }

    router.push('/login')
  }
}



// WEBPACK FOOTER //
// ./src/main.js